import { render, staticRenderFns } from "./ItemListDetailsChanges.vue?vue&type=template&id=ae3bfb06&scoped=true"
import script from "./ItemListDetailsChanges.vue?vue&type=script&lang=js"
export * from "./ItemListDetailsChanges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae3bfb06",
  null
  
)

export default component.exports